import React from 'react';
import { connect } from 'react-redux';

import { useUserFunctionality } from 'hooks';
import { Button } from 'portfolio3/ui-kit/button';

import { IconArrowRight } from '../../../../../icons';
import { IRootState } from '../../../../../reducers';

interface IProfileNoDataButtonProps {
  label: string;
  linkMode: boolean | undefined;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const ProfileNoDataButton: React.FC<IProfileNoDataButtonProps> = ({ label, linkMode, onClick }) => {
  const { isAdmin } = useUserFunctionality();

  return (
    <>
      {!linkMode && !isAdmin && (
        <Button size="medium" iconRight={<IconArrowRight />} onClick={onClick}>
          {label}
        </Button>
      )}
    </>
  );
};

export default connect((state: IRootState) => ({
  linkMode: state.linkMode.mode,
}))(ProfileNoDataButton);
